import { isServer } from '@finn/ui-utils/ssr';
import { SWRConfiguration } from 'swr';
import useSWR from 'swr/immutable';

import { useDiscoveryConfig } from '../data/MetadataProvider';
import {
  FiltersResponse,
  GetFiltersParams,
  VehicleViewKey,
} from '../helpers/filters';

export const useFetchFilters = (
  params: GetFiltersParams,
  isOutOfStock?: boolean,
  swrConfig?: SWRConfiguration
) => {
  const config = useDiscoveryConfig();

  if (!params.filters) {
    params.filters = {};
  }

  if (isOutOfStock) {
    params.filters.view = VehicleViewKey.DISPLAYED_CARS;
  }

  params.hide_related = true;

  if (!params?.filters.view) {
    params.filters.view = VehicleViewKey.AVAILABLE;
  }

  if (isServer()) {
    params = undefined;
  }

  return useSWR<FiltersResponse>(
    params,
    config.apiFetchers.fetchFilters,
    swrConfig
  );
};
